/**
 * Type tools.
 *
 * @module type
 * @license Apache-2.0
 * @author drmats
 */
export var isArray = Array.isArray;
export var isFunction = function isFunction(f) {
  return f != null && "function" === typeof f;
};
export var isNumber = function isNumber(n) {
  return n != null && "number" === typeof n && !Number.isNaN(n) && Number.isFinite(n);
};
export var isObject = function isObject(o) {
  return o != null && "object" === typeof o && !isArray(o);
};
export var isString = function isString(s) {
  return s != null && "string" === typeof s;
};
export var maxInt = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
export var minInt = Number.MIN_SAFE_INTEGER || -Math.pow(2, 53) + 1;
export var nullToUndefined = function nullToUndefined(val) {
  return val === null ? undefined : val;
};
export var toBool = function toBool(x) {
  return !!x;
};